import { render } from "./APIdocTable.vue?vue&type=template&id=08e85f9a"
import script from "./APIdocTable.vue?vue&type=script&lang=js"
export * from "./APIdocTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Sveve\\www\\vue\\sveve.no\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__